<template>
  <div>
    <div class="modal-backdrop show"></div>
    <div class="modal d-block" tabindex="-1" role="dialog">
      <div :class="{
        'modal-dialog modal-dialog-centered': true,
        [type]: true
      }" role="document">
        <div class="modal-content bs">
          <div class="modal-body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dom from '@/mixins/dom'

export default {
  mixins: [ dom ],
  props: {
    type: String
  },
  mounted () {
    this.addClass(document.body, 'modal-open')
  },
  beforeDestroy () {
    this.removeClass(document.body, 'modal-open')
  }
}
</script>
